import store from '../../../../store';
export default function checkIfCanDestroy() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('user_account_destroy_all') || scopes.includes('user_account_destroy_company')) {
    exists = true;
  }
  return exists;
}
